import { FC, PropsWithChildren, useEffect } from 'react';

import { useAnalytics } from '@bonusly/who-am-i';

import { parseEventData } from '../../utils/analytics';

export const AnalyticsProvider: FC<PropsWithChildren> = ({ children }) => {
	const { track } = useAnalytics();

	useEffect(() => {
		const listener = (e: MouseEvent) => {
			let target = e.target;

			while (target) {
				if (!target || !(target instanceof HTMLElement || target instanceof SVGElement)) {
					break;
				}

				const dataset = target.dataset;
				const { event, value } = parseEventData(dataset);

				if (event) {
					track(event, value);
				}

				const parent = target.parentElement;

				if (!parent) {
					break;
				}

				target = parent.closest('[data-analytics-event]');
			}
		};

		document.addEventListener('click', listener);

		return () => {
			document.removeEventListener('click', listener);
		};
	}, []);

	return <>{children}</>;
};
